import { computed } from 'vue'

export function useIsHomePage() {
  const { currentPath } = useRoutes()
  const isHomePage = computed(() => {
    return currentPath.value === '/dashboard'
  })

  return { isHomePage }
}
